<template>
  <div id="app">
    <!--<div class="kris-component-head">-->
      <!--<h1>Профсоюзная организация</h1>-->
    <!--</div>-->

    <!--<div class="kris-profsouz-box">-->
      <!--<div class="h2">Коллективно - договорное регулирование</div>-->
      <!--<br/>-->
      <!--<div class="">-->
      <!--</div>-->
      <div class="kris-documents-box">
        <div id="accordion1" class="panel-group">
          <div id="folders-from-ekis" v-if="items">
            <folder v-bind:key="item.folder.id" v-for="item in items" :info="item" parent="0" upload="uploadModal" />
          </div>
        </div>
      </div>
      <!--<div class="kris-profsouz-txt">-->
        <!--<div class="h2">Состав профсоюзного комитета:</div>-->
      <!--</div>-->
    <!--</div>-->

    <modal name="upload-modal" height="auto">
      <div class="upload" v-if="token">
        <h2>Выберите один или несколько файлов.</h2>
        <ul>
          <li v-for="(file, index) in files" :key="file.id">
            <span>{{file.name}}</span> -
            <span>{{file.size | formatSize}}</span> -
            <span v-if="file.error">{{file.error}}</span>
            <span v-else-if="file.success">success</span>
            <span v-else-if="file.active">active</span>
            <span v-else-if="file.active">active</span>
            <span v-else></span>
          </li>
        </ul>
        <div class="example-btn">
          <file-upload
            class="btn btn-primary"
            :data="{folder: selectFolder, token: token, eoId: eoId}"
            :post-action="api + upload"
            extensions="gif,jpg,jpeg,png,webp,pdf,zip,docx,xlsx"
            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf,application/zip,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :multiple="true"
            :size="1024 * 1024 * 32"
            v-model="files"
            @input-filter="inputFilter"
            @input-file="inputFile"
            ref="upload">
            <i class="fa fa-plus"></i>
            Выберите файлы
          </file-upload>
          <button type="button" class="btn btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
            <i class="fa fa-arrow-up" aria-hidden="true"></i>
            Начать загрузку
          </button>
          <button type="button" class="btn btn-danger"  v-else @click.prevent="$refs.upload.active = false">
            <i class="fa fa-stop" aria-hidden="true"></i>
            Остановить
          </button>
          <button type="button" @click.prevent="closeModal" class="btn btn-danger">Закрыть</button>
        </div>
      </div>
    </modal>

    <modal name="confirm-modal" height="120px" width="430px">
      <div class="confirm-modal">
        <h2>Вы действительно хотите удалить файл?</h2>
        <div class="">
          <a href="" @click.prevent="deleteFile" class="btn btn-danger">Удалить</a>
          <a href="" @click.prevent="hideConfirmModal" class="btn btn-default">Закрыть</a>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Folder from './components/Folder'
import FileUpload from 'vue-upload-component'
export default {
  name: 'app',
  computed: {
    ...mapState({
      items: 'folders',
      token: 'token',
      eoId: 'eoId',
      selectFolder: 'selectFolder',
      selectFile: 'selectFile',
      api: 'api',
      upload: 'uploadPath'
    })
  },
  components: {
    'folder': Folder,
    'file-upload': FileUpload
  },
  data () {
    return {
      files: []
    }
  },
  created () {
    this.$store.commit('setEoId', document.body.getAttribute('data-eo-id'))
    this.$store.commit('setToken', document.getElementById('app-folders-files').getAttribute('data-token'))
    this.$store.dispatch('getFolders')
  },
  methods: {
    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile (newFile, oldFile) {
      if (newFile && !oldFile) {
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        console.log('remove', oldFile)
      }
    },
    closeModal (e) {
      this.$modal.hide('upload-modal')
      this.$store.commit('setSelectFolder', false)
      this.$store.dispatch('getFolders')
    },
    hideConfirmModal (e) {
      this.$modal.hide('confirm-modal')
      this.$store.commit('setSelectFolder', false)
      this.$store.commit('setSelectFile', false)
    },
    deleteFile (e) {
      const $this = this
      this.$store.dispatch('deleteFile').then((res) => {
        // $this.$store.dispatch('getFolders')
        let file = document.getElementById('file-id-' + this.selectFile)
        file.style.display = 'none'
        $this.$modal.hide('confirm-modal')
      })
    }
  }
}
</script>

<style lang="less">
  .upload{
    padding: 20px;
    .example-btn{
      button{
        margin-left: 5px;
      }
    }
  }
  .confirm-modal{
    padding: 20px;
    .btn{
      margin: 10px 10px 0 0;
    }
  }
</style>
